// extracted by mini-css-extract-plugin
export default {"title":"SignUp_title__OjD6l","form":"SignUp_form__hi+We","labels":"SignUp_labels__MEH2d","inputs":"SignUp_inputs__QgNlL","signUpButton":"SignUp_signUpButton__PCs2X"};